var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListItem',{staticClass:"tourism-list-item",attrs:{"order":_vm.order}},[_c('p',{staticClass:"tourism-list-item__info"},[_vm._v("Номер полісу: "),_c('strong',[_vm._v(_vm._s(_vm.order.id))])])])}
var staticRenderFns = []

export { render, staticRenderFns }